import { keepPreviousData } from '@tanstack/react-query';

/**
 * Defaults for paginated list queries.
 * keepPreviousData keeps the prior page/filter visible while the next request loads.
 */
export const listQueryDefaults = {
  placeholderData: keepPreviousData,
};

/** True only on the first load when no cached or placeholder data exists yet. */
export function isInitialQueryLoading(isLoading: boolean, data: unknown): boolean {
  return isLoading && data === undefined;
}
